import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from "@angular/core";
import { LandingComponent } from "../pages/landing/landing.component";
import { ActiveLinkComponent } from "../pages/administration/active-link/active-link.component";
import { CallbackLoginComponent } from '../pages/auth/callback/callback-login.component';
import {Error404Component} from '../pages/error/404.component';
import { RefreshTokenComponent } from '../pages/auth/refresh-token/refresh-token.component';

export const noAuthRoutes: Routes = [
 {path: 'landing', component: LandingComponent},
 {path: 'active-link', component: ActiveLinkComponent},
 {path: 'callback-login', component: CallbackLoginComponent},
 {path: 'refresh-token', component: RefreshTokenComponent}
 //{path: '**', component: Error404Component} // 404
];

@NgModule({
  imports: [
    RouterModule.forRoot(noAuthRoutes)
  ],
  exports: [
    RouterModule
  ],
  providers: [

  ]
})

export class NoAuthRoutingModule { }




// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/routes/no-auth.routing.module.ts